import VChip from './VChip'

VChip.install = function install (Vue) {
  Vue.component(VChip.name, VChip)
}

export default VChip



// WEBPACK FOOTER //
// ./src/components/VChip/index.js